import { take, call, put } from 'redux-saga/effects';
import { get } from '../../utils/api';
import settings from '../../utils/settings';
import { UPLOAD_FILE_REQUEST, SAMPLE_FILE_REQUEST, SAMPLE_FILE_SUCCESS, SAMPLE_FILE_FAILURE } from './constants';
import { getToken } from '../../utils/helper';
import { isEmpty, get as lodashGet } from '../../utils/lodash';

export function* storeCreditFileUpload() {
  while (true) {
    const request = yield take(UPLOAD_FILE_REQUEST);
    const { file, successCbk = () => {}, failureCbk = () => {}, countryCode = '' } = request.payload;

    try {
      var formData = new FormData();
      formData.append('file', file, file.name);
      var requestOptions = {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${getToken()}` }
      };

      fetch(settings.einCoreUrl(`store/bulk/credits/${countryCode}`), requestOptions)
        .then(data =>
          data.json().then(response => {
            const { success = [], errors = [] } = response;
            if (!isEmpty(success) && isEmpty(errors)) {
              successCbk({ successList: success });
            } else {
              failureCbk({ successList: success, errorList: errors });
            }
          })
        )
        .catch(error => {
          failureCbk({ errorList: [], successList: [] });
        });
    } catch (error) {
      console.log('Saga: uploadFile:', error);
      failureCbk({ errorList: [], successList: [] });
    }
  }
}

export function* getSampleFileMerchandise() {
  while (true) {
    const request = yield take(SAMPLE_FILE_REQUEST);
    try {
      let response;
      const { countryCode } = request.payload;
      response = yield call(get, {
        url: settings.einCoreUrl(`store/sampleFiles/${countryCode}/merchandising`),
        withBearer: true
      });
      if (response.success) {
        yield put({ type: SAMPLE_FILE_SUCCESS, sampleFile: response.result });
      } else {
        const errorMessage =
          lodashGet(response, 'result.error', '') ||
          lodashGet(response, 'result.message', '') ||
          lodashGet(response, 'result.messages', '');
        yield put({ type: SAMPLE_FILE_FAILURE, error: errorMessage });
      }
    } catch (error) {
      console.log('Saga: getSampleFileMerchandise', error);
      yield put({ type: SAMPLE_FILE_FAILURE, error: error });
    }
  }
}
